import React from 'react';
import Loadable from 'react-loadable';
import Loading from '../../utils/animation/loading';
import _, {cloneDeepWith, isEmpty} from 'lodash';
import { fetchWithToken } from './EpfTokensUtils';

const logFrontEndLoggers = (msgData: object) => {
    const ParsedData = cloneDeepWith(msgData, (value) => {
      try {
        return JSON.parse(value);
      } catch (error) {
        return undefined;
      }
    });
    const loadableData = JSON.stringify(ParsedData);
    fetchWithToken('/cvrservices/eppublic/frontEndLogger?msg=loadable', {
      method: 'POST',
      body: loadableData,
    })
      .then((response) => {
        console.log('Success Responsive:' + response);
      })
      .catch((err) => {
        console.log('err:' + err);
      });
  };

type LogEntry = string[];

let errorLogs : LogEntry = [];
let warnLogs : LogEntry = [];

const sendLogs = async () => {
    const logs = {
        error: errorLogs,
        warnings: warnLogs,
    };

    await logFrontEndLoggers(logs);
    console.log("Logs sent successfully to front end logger");

    //clear logs
    errorLogs = [];
    warnLogs = [];
}
let intervalId: number | null = null;
let counter = 0;

const startLogInterval = () => {
    if(intervalId === null) {
        intervalId = window.setInterval(() => {
            if(!isEmpty(errorLogs) || !isEmpty(warnLogs)) {
                console.log("Sending logs to frontEndLogger");
                sendLogs();
            } 
            counter += 1;
            if (counter >= 10) { //only send logs 10 times (2 mins)
                clearInterval(intervalId!);
                intervalId = null;
            }                
        }, 12000);
    }
}

//start recording msgs for 12 seconds and send them to front end logger, repeat for 10 times.
startLogInterval();

const LoadableLoading = (props: any, componentName: string, startTime: number) => {
    console.log("LoadableLoading: ", componentName, " Time taken: ", Date.now()-startTime, " ms"); 
    if (props.error) {
        const errorMsg = `LoadableLoading error: ${props.error}`;
        errorLogs.push(errorMsg);
        console.error("LoadableLoading error:", props, props.error);
        return <div className="loadable-state" id="react-loadable-error"> Error! {componentName}<button onClick={props.retry}> Retry  </button></div>;
    } else if (props.timedOut) {
        console.warn("LoadableLoading timeout:", props, componentName, "  Time taken: ", Date.now()-startTime, " ms");
        return <div className="loadable-state" id="react-loadable-timedOut"> Taking a long time... {componentName} <button onClick={props.retry}> Retry </button></div>;
    } else if (props.pastDelay) {
        if (window.HTML_RENDITION.initialData.showOldLoading) {
            return <div className="loadable-state" id="react-loadable-loading"> <Loading /></div>;
        } else {
            return <div></div>;
        }
    } else {
        return null;
    }
};

export const RenditionLoadable = (opts: any, componentName: any, startTime: any) => {   
    return Loadable(Object.assign({
        delay: 300,
        timeout: 10000,
        loading: (props: any) => {
            return LoadableLoading(props, componentName, startTime);
        },
        render(loaded: any, props: object) {
            const ComponentL = loaded.default;
            return <ComponentL {...props} />;
        }
    }, opts));
};
